import { fecthGet, fecthPost } from '@/hotelcem/apis/request'
const newBaseUrl = `${process.env.VUE_APP_APIBASEURL}/api/v1/general`
export default {
  changeMenuVersion(params) {
    return fecthPost('/user/menu/version/update', params, { baseURL: newBaseUrl })
  },
  getSystemList() {
    return fecthGet('/user/app/list', {}, { baseURL: newBaseUrl })
  },
  getTenant() {
    return fecthGet('/apollo/query-common-config?key=newMenuTenant')
  },
  // AI生成回复
  listAIReplyTemplate(params, cancelAxios) {
    const url = '/cem/hotel/chat/completions'
    return fecthPost(url, params, {
      cancelToken: new axios.CancelToken(c => {
        cancelAxios[url] = c
      }),
    })
  },
  // 创建任务id
  listAIReplyGetTaskId(params) {
    const url = '/comment/reply-content/ai-analysis'
    return fecthPost(url, params, {
      baseURL: newBaseUrl,
    })
  },
  // 重试
  listAIReplyRetry(params) {
    const url = '/ai-analysis/retry'
    return fecthPost(url, params, {
      baseURL: newBaseUrl,
    })
  },
  // 获取ai回复
  listAIReplyGetTemplate(params, cancelAxios, cancelUrl) {
    const url = cancelUrl || '/ai-analysis/result'
    return fecthGet(url, params, {
      cancelToken: new axios.CancelToken(c => {
        cancelAxios[url] = c
      }),
      baseURL: newBaseUrl,
    })
  },
  // 反馈内容
  listAIReplyFeedback(params) {
    const url = '/ai-analysis/addOpinion'
    return fecthPost(url, params, {
      baseURL: newBaseUrl,
    })
  },
  // 编辑模版
  editorReplyTemplate(params) {
    return fecthPost('/cem/hotel/comment/reply-template/edit', params)
  },
  /**
   * 查询回复模板列表
   * @param {"hotelId":"","pageNo":1,"pageSize":10} params
   * @returns
   */
  listReplyTemplate(params) {
    return fecthPost('/cem/hotel/comment/reply-template/list', params)
  },
  /**
   * 添加回复模板
   * @param {"hotelId":"","content": "我没有问题"} params
   * @returns
   */
  addReplyTemplate(params) {
    return fecthPost('/cem/hotel/comment/reply-template/add', params)
  },
  /**
   * 查询回复模板数量
   * @param {"hotelId":""} params
   * @returns
   */
  getReplyTemplateCount(params) {
    return fecthPost('/cem/hotel/comment/reply-template/count', params)
  },
  /**
   * 添加回复模板
   * @param {"templateId":""} params
   * @returns
   */
  delReplyTemplate(params) {
    return fecthGet('/cem/hotel/comment/reply-template/del', params)
  },
  /**
   * 点评管理banner展示数据
   * @param {"startTs": 'Long',"endTs": 'Long',"hotelId":'String'} params
   * @returns
   */
  getCommentBadTotal(params) {
    let url = params.isGroup ? '/cem/comment/bad/total/group' : '/cem/comment/bad/total'
    return fecthPost(url, params)
  },

  /**
   * 点评管理核心指标树
   * @param {"groupId":xxx,"startTs":xxx,"endTs":xxx,"hotelId":xxx,"channel":xxx,"minScore":xxx,"maxScore":xxx,"cate":xxx,"isReply":xxx,"feature":xx} params
   * @returns
   */
  listCommentLabelsTree(params) {
    let url = params.isGroup ? 'cem/multi/detailTreeQuery ' : '/cem/dataCube2/detailTreeQuery'
    return fecthPost(url, params)
  },
  /**
   * 点评管理记录列表
   * @param {"startTs":xxx//long开始时间,"endTs":xxx//long结束时间,"hotelId":xxx//string酒店ID,"channel":xxx//string渠道xc携程/mt美团,"minScore":xxx//double最低评分,"maxScore":xxx//double最高评分,"cate":xxx//string整句情感positive:正面neutral：中立bad：负面,"isReply":xxx//int是否回复0：未回复1：已回复,"feature":xxx//int评论特征1：首页批评2：负面观点较多,"label":{"label_1":"xxx","label_2":"xxx","label_3":"xxx"},"labelCate":xxx//string观点类型,"topic":"xxx","topicCate""positive/neutral/bad"//string主题情感,"from":xx//int从第几条记录开始,"size":xxx//int查询size条记录,"orderBy":col//排序字段默认时间降序,"orderType""desc/asc"//desc降序asc升序} params
   * @returns
   */
  listCommentRawData(params) {
    let url = params.isGroup ? '/cem/multi/detailQuery' : '/cem/dataCube2/detailQuery'
    return fecthPost(url, params)
  },
  /**
   * 渠道账户状态检查
   * @param {channel: 'trip'} params
   * @returns
   */
  getReplyAccountState(params) {
    return fecthGet('/cem/company/comment/channel/state', params)
  },
  /**
   * 检查回复打标情况
   * @param {*} params
   * @returns
   */
  getCommentTextCodes(params) {
    params.timeout = 10000
    return fecthPost('/cem/comment/text/codes', params, { timeout: 10000 })
  },
  /**
   * 批量回复接口
   * @param {channel: 'trip'} params
   * @returns
   */
  batchReplyComment(params) {
    return fecthPost('/cem/comment/reply', params)
  },
  /**
   * 查询工单列表
   * @param {attributeKey: String, attributeValues: Array<String>} params
   * @returns
   */
  listWorkOrder(params) {
    return fecthPost('/work-order/list-by-attribute', params)
  },
  /**
   * 查询工单列表
   * @param {attributeKey: String, attributeValues: Array<String>} params
   * @returns
   */
  listByPoint(params) {
    return fecthPost('/cem/comment/voice-label/list-by-point', params)
  },
  /**
   * 纠错
   * @param {
      "commentDate": 15565,// `评论时间` 
      "content": "xx",// `评论内容` 
      "dataCid": "xxxx",// `点评id` 
      "errorTypeLabel1": "xxx",// `1:语义分析问题2:外网已修改分值或内容3:外网已删除/折叠4:其他原因` 
      "errorTypeLabel2s": [
        "xx"
      ], // `二级错误标签  情感有误，标签有误，观点分析遗漏` 
      "hotelId": "xxx",// `酒店id` 
      "remark": "xxx",// `备注说明信息` 
      "source": 1,// `评论来源  1:美团2:携程3:飞猪4:艺龙` 
    } params
   * @returns
   */
  qualityCreate(params) {
    return fecthPost('/cem/hotel/comment/quality/create', params)
  },
  // 根据酒店查询部门
  deptListByHotel(params) {
    return fecthGet(`/cem/hotel/department/list-by-hotelId`, params)
  },
  // 根据酒店和部门查询标签
  getLabelsByDept(params) {
    return fecthPost(`/cem/label/department-labels`, params)
  },
  // 导出分析
  exportAnalysis(params) {
    return fecthPost('/cem/export/comment/export2', params)
  },
  // 查询租户是否可补充点评会员卡信息
  fetchVIPCardPermission() {
    return fecthGet('/cem/comment/negpoint/replenish/tenant')
  },
  // 查询租户是否万达
  fetchIsWanda() {
    try {
      let id = process.env.VUE_APP_ENV === 'prod' ? '921973' : '471186'
      let info = JSON.parse(localStorage.getItem('VOCUST_APP_BASE_ID'))
      if (info && info.userInfo && info.userInfo.tenantId === id) {
        return Promise.resolve({ code: 200, data: true })
      } else {
        return Promise.resolve({ code: 200, data: false })
      }
    } catch (e) {
      console.error(e)
      return Promise.reject(e)
    }
    // return fecthGet('/cem/complaint/tenant/wanda')
  },
  // 差评补充会员信息卡号
  saveVIPCardNo(params) {
    return fecthPost('/cem/comment/negpoint/replenish', params)
  },
  // 差评补充会员信息查询列表
  fetchVIPCardNoList(params) {
    return fecthPost('/cem/comment/negpoint/replenish/list2', params)
  },
  // 是否质检
  fetchIsQuality(params) {
    return fecthPost('/cem/hotel/comment/quality/commentQualityStatus', params)
  },
  // 反馈记录
  fetchcommentQualityList(params) {
    return fecthGet('/cem/hotel/comment/quality/commentQualityList', params)
  },
  getCommentQualityDetail(params) {
    return fecthGet('/cem/hotel/comment/quality/commentQualityDetail', params)
  },
  getVoiceCommentQualityDetail(params) {
    return fecthGet('/warn/record/error/voiceQualityDetail', params)
  },
  // 点评撤销反馈记录
  cancelFeedback(params) {
    return fecthPost('/cem/hotel/comment/quality/revocation', params)
  },
  // 点评列表页查询差评数量接口
  fetchComplaintCommentCount(params) {
    return fecthPost('/cem/complaint/queryComplaintCommentCount', params)
  },
  /**
   * 查询分析的原始数据列表4
   */
  fetchOriginDataList(params) {
    return fecthPost('/data-source/group/raw/data/analysis/list', params)
  },
  /**
   * 获取最近添加的数据源2
   */
  fetchNewSourceList(params) {
    return fecthGet('/data-source/group/simplifiedNoTenant', params)
  },

  fetchTrendData(params) {
    ///cem/comment/score/trend/info
    return fecthGet('/cem/comment/score/trend/info', params)
  },
  fetchNewTrendData(params) {
    ///cem/comment/score/trend/info
    return fecthGet('/cem/comment/score/neural/prediction/info', params)
  },
  exportNewTrendData(params) {
    ///cem/comment/score/trend/info   /commentDetailScorePrediction/export
    return fecthGet('/cem/export/comment/Score/Prediction/export', params)
  },
  fetchTrendDataB(params) {
    ///cem/comment/score/trend/info
    return fecthGet('cem/comment/score/neural/trend/info', params)
  },

  fetchStyleList() {
    return fecthGet('/comment-reply/ai/comment-style/list', {}, { baseURL: '/api/v1/cem-4x' })
  },

  messageRead(params) {
    return fecthGet('/comment/click', params, { baseURL: '/api/v1/cem-4x' })
  },

  saveCustomStyle(params) {
    return fecthPost('/comment-reply/ai/custom-style/save', params, { baseURL: '/api/v1/cem-4x' })
  },

  updateCustomStyle(params) {
    return fecthPost('/comment-reply/ai/custom-style/update', params, { baseURL: '/api/v1/cem-4x' })
  },

  changeCustomStyle(params) {
    return fecthPost('/comment-reply/ai/user-style/save', params, { baseURL: '/api/v1/cem-4x' })
  },
  AIReplyGetTaskId(params) {
    const url = '/comment-reply/ai/analysis/generate-content'
    return fecthPost(url, params, {
      baseURL: '/api/v1/cem-4x',
    })
  },
  AIReplyGetTranslateTaskId(params) {
    return fecthPost('/comment-reply/ai/analysis/content-translate', params, {
      baseURL: '/api/v1/cem-4x',
    })
  },
  // 昨日CSI分
  fetchYesterdayCsiScore(params) {
    return fecthPost('/comment/csi-score', params, { baseURL: '/api/v1/cem-4x' })
  },
  // 渠道平均分
  fetchChannelAvgScore(params) {
    return fecthPost('/comment/comment-avg-score', params, { baseURL: '/api/v1/cem-4x' })
  },
  //新增统计等
  fetchCommentStatistics(params) {
    return fecthPost('/comment/statistics', params, { baseURL: '/api/v1/cem-4x' })
  },
  // 点评回复相关
  fetchCommentReplyList(params) {
    return fecthPost('/comment/reply/statistics', params, { baseURL: '/api/v1/cem-4x' })
  },
  // 表扬观点top榜
  fetchViewTopList(params) {
    return fecthPost('/comment/label/top', params, { baseURL: '/api/v1/cem-4x' })
  },
  // 客诉预警相关
  fetchComplaintWarnList(params) {
    return fecthPost('/voice-statistics/complaint-warn/statistics', params, { baseURL: '/api/v1/cem-4x' })
  },
  // 语音量统计
  fetchVoiceVolumeStatistics(params) {
    return fecthPost('/voice-statistics/demand/total', params, { baseURL: '/api/v1/cem-4x' })
  },
  // 客诉观点top榜
  fetchComplaintViewTopList(params) {
    return fecthPost('/voice-statistics/complaint/top', params, { baseURL: '/api/v1/cem-4x' })
  },
  // 客诉统计
  fetchComplaintStatistics(params) {
    return fecthPost('/voice-statistics/statistics', params, { baseURL: '/api/v1/cem-4x' })
  },
  // 客诉观点
  fetchComplaintViewStatistics(params) {
    return fecthPost('/voice-statistics/label/statistics', params, { baseURL: '/api/v1/cem-4x' })
  },
  // 渠道信息分析
  fetchChannelInfo(params) {
    return fecthPost('/comment/channel/info/analysis', params, { baseURL: '/api/v1/cem-4x' })
  },
  // 抖音渠道验证状态查询
  fetchDouyinStatus(params) {
    return fecthPost('/comment/channel/check/expired-info', params, { baseURL: '/api/v1/cem-4x' })
  },
}
